import {client} from ".";

const LOGIN_URL = "/login";

export default async (data) => {
    const {body} = await client.send("post", LOGIN_URL, data);
    return body;
};
